import { render, staticRenderFns } from "./WorkStationView.vue?vue&type=template&id=7081ae44&scoped=true&"
import script from "./WorkStationView.vue?vue&type=script&lang=js&"
export * from "./WorkStationView.vue?vue&type=script&lang=js&"
import style0 from "./WorkStationView.vue?vue&type=style&index=0&id=7081ae44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7081ae44",
  null
  
)

export default component.exports